import { LocationOn, MyLocation } from '@mui/icons-material';
import { Box, Stack, type SvgIcon, Typography } from '@mui/material';
import type { HTMLAttributes } from 'react';
import { highlightSubstring } from '@/common/utils/string';
import type { Location } from '@/views/Community/views/CommunityListings/CommunityListings.state';

const iconsByOptionId: Record<string, typeof SvgIcon> = {
  currentLocation: MyLocation,
};

type Props = HTMLAttributes<HTMLLIElement> & {
  option: Location;
  searchTerm?: string;
};

export function Option({ option, searchTerm, ...optionProps }: Props) {
  if (!option) {
    return null;
  }

  const { label, secondaryLabel } = option;
  const Icon = iconsByOptionId[option.id] ?? LocationOn;

  return (
    <Stack
      component="li"
      direction="row"
      sx={{
        alignItems: 'center',
        gap: 2,
        flexWrap: 'noWrap',
      }}
      {...optionProps}
    >
      <Icon sx={{ color: 'action.active' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          wordBreak: 'break-word',
        }}
      >
        {label && (
          <Typography
            variant="body2"
            // biome-ignore lint/security/noDangerouslySetInnerHtml: Needed for highlighting
            dangerouslySetInnerHTML={{
              __html: searchTerm
                ? highlightSubstring(label, searchTerm)
                : label,
            }}
          />
        )}
        {secondaryLabel && (
          <Typography
            variant="body2"
            sx={{
              pt: 0.25,
              color: 'text.secondary',
            }}
          >
            {secondaryLabel}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
